export const PREVIOUS = -1;
export const NEXT = 1;
